/* WSS site header behaviour (sections/wss-header.liquid).
   Desktop (1220px and up): mega panels (hover intent, touch, keyboard), search panel
   and predictive results. Below 1220px: drill-down drawer and full-screen search.
   Also keeps the cart badge in sync (Empire "cartcount:update" event plus any
   /cart/add|change|update|clear request made by the theme or an app). */
(function () {
  'use strict';
  if (window.WSSHeader) { window.WSSHeader.scan(document); return; }

  var DESKTOP = window.matchMedia('(min-width: 1220px)');
  var instances = [];

  function qs(el, s) { return el ? el.querySelector(s) : null; }
  function qsa(el, s) { return el ? Array.prototype.slice.call(el.querySelectorAll(s)) : []; }
  function isVisible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function focusables(el) {
    return qsa(el, 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(isVisible);
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function words(q) { return String(q || '').toLowerCase().split(/\s+/).map(norm).filter(Boolean); }
  function hits(text, ws) { var n = norm(text); return ws.length > 0 && ws.every(function (w) { return n.indexOf(w) !== -1; }); }
  function path(u) { try { return new URL(u, location.origin).pathname.replace(/\/$/, '').toLowerCase(); } catch (e) { return String(u || ''); } }
  function uniq(list) {
    var seen = {};
    return list.filter(function (x) { if (!x || !x.u) return false; var k = path(x.u); if (seen[k]) return false; seen[k] = true; return true; });
  }

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] != null) el.setAttribute(k, attrs[k]); });
    (kids || []).forEach(function (k) { if (k == null) return; el.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); });
    return el;
  }
  function svg(d, size, sw, cls) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('class', 'wssh-i' + (cls ? ' ' + cls : ''));
    s.setAttribute('width', size); s.setAttribute('height', size); s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', sw);
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', d); s.appendChild(p);
    return s;
  }
  var ICON_RIGHT = 'M9 6l6 6-6 6';
  var ICON_ARROW = 'M5 12h14M13 6l6 6-6 6';

  function formatMoney(value, format) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    format = format || '${{amount}}';
    function delim(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(n, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(n, 2, "'", '.');
        default: return delim(n, 2, ',', '.');
      }
    });
  }

  /* Page scroll lock shared by the drawer and the phone search */
  var locks = 0;
  function lock() { locks += 1; document.documentElement.classList.add('wssh-lock'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) document.documentElement.classList.remove('wssh-lock'); }

  function Header(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.listeners = [];
    this.timers = {};
    this.cache = {};
    this.seq = 0;
    this.open = null;
    var data = {};
    try { data = JSON.parse(qs(root, '[data-wssh-data]').textContent); } catch (e) { data = {}; }
    this.data = data;
    this.brands = uniq(data.brands || []);
    this.cats = uniq(data.cats || []);
    this.noResults = qs(root, '[data-wssh-noresults]');

    this.initNav();
    this.initSearch();
    this.initDrawer();
    this.initPhoneSearch();
    this.initCart();

    var self = this;
    this.on(document, 'keydown', function (e) { self.onEscape(e); });
    this.on(document, 'pointerdown', function (e) { self.onDocPointer(e); });
    this.on(window, 'resize', function () { if (self.open) self.sizeScrim(); });
    this.onMedia = function () { self.closeAll(); };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', this.onMedia); else DESKTOP.addListener(this.onMedia);
  }

  Header.prototype.on = function (el, type, fn, opts) {
    if (!el) return;
    el.addEventListener(type, fn, opts);
    this.listeners.push([el, type, fn, opts]);
  };

  Header.prototype.destroy = function () {
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    this.listeners = [];
    Object.keys(this.timers).forEach(function (k) { clearTimeout(this.timers[k]); }, this);
    if (DESKTOP.removeEventListener) DESKTOP.removeEventListener('change', this.onMedia); else DESKTOP.removeListener(this.onMedia);
    if (this.drawerOpen) unlock();
    if (this.psOpen) unlock();
  };

  Header.prototype.closeAll = function () {
    this.close(false);
    if (this.drawerOpen) this.closeDrawer(false);
    if (this.psOpen) this.closePs(false);
  };

  /* ---------------- Desktop menu bar ---------------- */

  Header.prototype.initNav = function () {
    var self = this;
    this.nav = qs(this.root, '[data-wssh-nav]');
    this.scrim = qs(this.root, '[data-wssh-scrim]');
    this.triggers = qsa(this.root, '[data-wssh-trigger]');
    this.triggers.forEach(function (btn) {
      var id = btn.getAttribute('data-wssh-trigger');
      self.on(btn, 'pointerdown', function (e) { self.lastPointer = e.pointerType; });
      self.on(btn, 'click', function (e) { self.onTriggerClick(e, id, btn); });
      self.on(btn, 'pointerenter', function (e) { if (e.pointerType === 'mouse') self.onTriggerEnter(id); });
      self.on(btn, 'pointerleave', function (e) { if (e.pointerType === 'mouse') clearTimeout(self.timers.hover); });
      self.on(btn, 'keydown', function (e) { self.onTriggerKey(e, id, btn); });
    });
    qsa(this.root, '[data-wssh-close]').forEach(function (b) {
      self.on(b, 'click', function () { self.close(true); });
    });
    this.on(this.scrim, 'click', function () { self.close(false); });
    this.on(this.scrim, 'pointerenter', function (e) { if (e.pointerType === 'mouse' && self.hoverOpen) self.scheduleClose(); });
    this.on(this.root, 'pointerleave', function (e) { if (e.pointerType === 'mouse' && self.hoverOpen) self.scheduleClose(); });
    this.on(this.nav, 'pointerover', function () { clearTimeout(self.timers.close); });
    this.on(this.nav, 'focusout', function (e) {
      var id = self.open;
      if (!id || id === 'search') return;
      var to = e.relatedTarget;
      if (!to) return;
      var panel = self.panel(id);
      if (to === self.trigger(id) || (panel && panel.contains(to))) return;
      self.close(false);
    });
  };

  Header.prototype.trigger = function (id) {
    return this.triggers.filter(function (b) { return b.getAttribute('data-wssh-trigger') === id; })[0] || null;
  };
  Header.prototype.panel = function (id) {
    return qsa(this.root, '[data-wssh-panel]').filter(function (p) { return p.getAttribute('data-wssh-panel') === id; })[0] || null;
  };

  Header.prototype.onTriggerClick = function (e, id, btn) {
    clearTimeout(this.timers.hover);
    var pointer = e.detail === 0 ? '' : (e.pointerType || this.lastPointer || '');
    this.lastPointer = null;
    if (btn.tagName === 'A') {
      /* Category links: a mouse click or Enter goes to the page. Touch has no hover, so the
         first tap opens the panel and a second tap on the open item follows the link. */
      if ((pointer === 'touch' || pointer === 'pen') && this.open !== id) {
        e.preventDefault();
        this.openPanel(id, false);
      }
      return;
    }
    if (this.open === id) {
      /* A click right after hover opened it keeps it open (and pins it) instead of closing it. */
      if (this.hoverOpen && Date.now() - this.openedAt < 600) { this.hoverOpen = false; return; }
      this.close(false);
      return;
    }
    this.openPanel(id, false);
  };

  Header.prototype.onTriggerEnter = function (id) {
    var self = this;
    if (!DESKTOP.matches || this.open === 'search') return;
    clearTimeout(this.timers.hover);
    clearTimeout(this.timers.close);
    if (this.open === id) return;
    if (this.open) { this.openPanel(id, this.hoverOpen); return; }
    this.timers.hover = setTimeout(function () { self.openPanel(id, true); }, 150);
  };

  Header.prototype.onTriggerKey = function (e, id, btn) {
    var key = e.key;
    if ((key === ' ' || key === 'Spacebar') && btn.tagName === 'A') {
      /* Space opens and closes a category link's panel (Enter follows the link). */
      e.preventDefault();
      if (this.open === id) this.close(false); else this.openPanel(id, false);
    } else if (key === 'ArrowDown') {
      e.preventDefault();
      this.openPanel(id, false);
      var first = focusables(this.panel(id))[0];
      if (first) first.focus();
    } else if (key === 'ArrowRight' || key === 'ArrowLeft') {
      var items = focusables(this.nav).filter(function (el) { return el.hasAttribute('data-wssh-trigger') || el.classList.contains('wssh-navhelp'); });
      var i = items.indexOf(btn);
      if (i < 0) return;
      e.preventDefault();
      var next = items[(i + (key === 'ArrowRight' ? 1 : -1) + items.length) % items.length];
      if (next) next.focus();
    }
  };

  Header.prototype.scheduleClose = function () {
    var self = this;
    clearTimeout(this.timers.close);
    this.timers.close = setTimeout(function () { if (self.hoverOpen) self.close(false); }, 300);
  };

  Header.prototype.hidePanels = function () {
    this.triggers.forEach(function (b) { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); });
    qsa(this.root, '[data-wssh-panel]').forEach(function (p) { p.hidden = true; });
  };

  Header.prototype.openPanel = function (id, viaHover) {
    clearTimeout(this.timers.close);
    if (this.open === id) { if (!viaHover) this.hoverOpen = false; return; }
    var panel = this.panel(id);
    var btn = this.trigger(id);
    if (!panel || !btn) return;
    if (this.open === 'search') this.closeSearch();
    this.hidePanels();
    panel.hidden = false;
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    this.open = id;
    this.hoverOpen = !!viaHover;
    this.openedAt = Date.now();
    this.showScrim();
  };

  Header.prototype.close = function (returnFocus) {
    var was = this.open;
    if (!was) return;
    clearTimeout(this.timers.close);
    if (was === 'search') { this.closeSearch(); return; }
    this.hidePanels();
    this.open = null;
    this.hoverOpen = false;
    this.hideScrim();
    if (returnFocus) { var b = this.trigger(was); if (b) b.focus(); }
  };

  Header.prototype.showScrim = function () {
    if (!this.scrim) return;
    this.scrim.hidden = false;
    this.sizeScrim();
  };
  Header.prototype.sizeScrim = function () {
    if (!this.scrim || this.scrim.hidden) return;
    this.scrim.style.height = '0px';
    var top = this.scrim.getBoundingClientRect().top + window.pageYOffset;
    var docH = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    this.scrim.style.height = Math.max(docH - top, window.innerHeight) + 'px';
  };
  Header.prototype.hideScrim = function () {
    if (this.scrim && !this.open) this.scrim.hidden = true;
  };

  Header.prototype.onEscape = function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (this.psOpen) { e.preventDefault(); this.closePs(true); return; }
    if (this.drawerOpen) { e.preventDefault(); this.closeDrawer(true); return; }
    if (this.open === 'search') {
      e.preventDefault();
      this.closeSearch();
      if (this.input) this.input.focus();
      return;
    }
    if (this.open) { e.preventDefault(); this.close(true); }
  };

  Header.prototype.onDocPointer = function (e) {
    if (!this.open) return;
    var t = e.target;
    if (this.open === 'search') {
      if (!this.searchWrap.contains(t) && !this.sopen.contains(t)) this.closeSearch();
      return;
    }
    if (!this.root.contains(t)) this.close(false);
  };

  /* ---------------- Desktop search ---------------- */

  Header.prototype.initSearch = function () {
    var self = this;
    this.searchWrap = qs(this.root, '[data-wssh-search]');
    this.sopen = qs(this.root, '[data-wssh-sopen]');
    if (!this.searchWrap || !this.sopen) return;
    this.form = qs(this.searchWrap, '[data-wssh-form]');
    this.input = qs(this.searchWrap, '[data-wssh-q]');
    this.results = qs(this.searchWrap, '[data-wssh-results]');
    this.status = qs(this.searchWrap, '[data-wssh-status]');

    this.on(this.input, 'focus', function () { self.openSearch(); });
    this.on(this.input, 'click', function () { self.openSearch(); });
    this.on(this.input, 'input', function () { self.openSearch(); self.queue('d', false); });
    this.on(this.form, 'submit', function (e) { self.submit(e, self.input); });
    this.on(this.input, 'keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var box = !self.results.hidden ? self.results : (!self.sopen.hidden ? self.sopen : null);
      var first = box ? qsa(box, 'a[href], button').filter(isVisible)[0] : null;
      if (first) { e.preventDefault(); first.focus(); }
    });
    this.on(this.results, 'keydown', function (e) { self.arrowNav(e, self.results, self.input); });
    qsa(this.sopen, '[data-wssh-term]').forEach(function (b) {
      self.on(b, 'click', function () {
        self.input.value = b.getAttribute('data-wssh-term');
        self.input.focus();
        self.openSearch();
        self.queue('d', true);
      });
    });
    var leave = function (e) {
      if (self.open !== 'search') return;
      var to = e.relatedTarget;
      if (!to) return;
      if (self.searchWrap.contains(to) || self.sopen.contains(to)) return;
      self.closeSearch();
    };
    this.on(this.searchWrap, 'focusout', leave);
    this.on(this.sopen, 'focusout', leave);
  };

  Header.prototype.openSearch = function () {
    if (!DESKTOP.matches || !this.input) return;
    if (this.open && this.open !== 'search') { this.hidePanels(); }
    clearTimeout(this.timers.hover);
    this.open = 'search';
    this.hoverOpen = false;
    this.root.classList.add('is-search');
    var hasQ = !!this.input.value.trim();
    this.sopen.hidden = hasQ;
    if (!hasQ) this.results.hidden = true;
    else if (this.results.hidden) { this.results.hidden = !this.results.firstChild; if (!this.results.firstChild) this.queue('d', true); }
    this.showScrim();
  };

  Header.prototype.closeSearch = function () {
    if (!this.sopen) return;
    this.sopen.hidden = true;
    this.results.hidden = true;
    this.root.classList.remove('is-search');
    if (this.open === 'search') { this.open = null; this.hideScrim(); }
  };

  Header.prototype.arrowNav = function (e, box, input) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var items = qsa(box, 'a[href]').filter(isVisible);
    var i = items.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') (items[i + 1] || items[0]).focus();
    else if (i === 0) input.focus();
    else items[i - 1].focus();
  };

  Header.prototype.searchUrl = function (q) {
    return (this.data.search || '/search') + '?q=' + encodeURIComponent(q);
  };

  Header.prototype.submit = function (e, input) {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); }
  };

  Header.prototype.queue = function (mode, now) {
    var self = this;
    clearTimeout(this.timers['q' + mode]);
    var input = mode === 'p' ? this.psInput : this.input;
    if (!input) return;
    if (!input.value.trim()) { this.showEmpty(mode); return; }
    this.showBusy(mode);
    this.timers['q' + mode] = setTimeout(function () { self.run(mode); }, now ? 0 : 180);
  };

  Header.prototype.showEmpty = function (mode) {
    this.seq += 1;
    if (this.ctrl) { try { this.ctrl.abort(); } catch (e) { /* ignore */ } }
    if (mode === 'p') {
      this.psEmpty.hidden = false;
      this.psResults.hidden = true;
      this.psResults.textContent = '';
      this.psStatus.textContent = '';
    } else {
      this.results.hidden = true;
      this.results.textContent = '';
      this.status.textContent = '';
      if (this.open === 'search') this.sopen.hidden = false;
    }
  };

  Header.prototype.showBusy = function (mode) {
    if (mode === 'p') {
      this.psEmpty.hidden = true;
      this.psResults.hidden = false;
      if (!this.psResults.firstChild) this.psResults.appendChild(h('p', { 'class': 'wssh-loading wssh-ps__pad' }, ['Searching...']));
      this.psResults.setAttribute('aria-busy', 'true');
    } else {
      this.sopen.hidden = true;
      if (!this.results.firstChild) {
        this.results.appendChild(h('div', { 'class': 'wssh-results__main' }, [h('p', { 'class': 'wssh-loading' }, ['Searching...'])]));
      }
      this.results.classList.add('is-busy');
      this.results.setAttribute('aria-busy', 'true');
      if (this.open === 'search') this.results.hidden = false;
    }
  };

  Header.prototype.fetchSuggest = function (term) {
    var self = this;
    var key = term.toLowerCase();
    if (this.cache[key]) return Promise.resolve(this.cache[key]);
    if (this.ctrl) { try { this.ctrl.abort(); } catch (e) { /* ignore */ } }
    this.ctrl = window.AbortController ? new AbortController() : null;
    var params = new URLSearchParams();
    params.set('q', term);
    params.set('resources[type]', 'product,collection');
    params.set('resources[limit]', '5');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'last');
    return fetch((this.data.suggest || '/search/suggest.json') + '?' + params.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      signal: this.ctrl ? this.ctrl.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('suggest ' + r.status);
      return r.json();
    }).then(function (json) {
      var res = (json && json.resources && json.resources.results) || {};
      var out = { products: res.products || [], collections: res.collections || [] };
      self.cache[key] = out;
      return out;
    });
  };

  Header.prototype.run = function (mode) {
    var self = this;
    var input = mode === 'p' ? this.psInput : this.input;
    var q = input.value.trim();
    if (!q) { this.showEmpty(mode); return; }
    var token = ++this.seq;
    this.fetchSuggest(q).then(function (data) {
      if (token !== self.seq) return;
      self.render(mode, q, self.model(q, data));
    }).catch(function (err) {
      if (token !== self.seq || (err && err.name === 'AbortError')) return;
      self.render(mode, q, { products: [], cats: [], brands: [], failed: true });
    });
  };

  Header.prototype.model = function (q, data) {
    var self = this;
    var ws = words(q);
    var byPath = {};
    this.brands.forEach(function (b) { byPath[path(b.u)] = b; });
    var cats = [];
    var brands = [];
    data.collections.forEach(function (c) {
      var b = byPath[path(c.url)];
      if (b) brands.push(b); else cats.push({ l: c.title, u: c.url });
    });
    this.cats.forEach(function (c) { if (hits(c.l, ws)) cats.push(c); });
    this.brands.forEach(function (b) { if (hits(b.l, ws)) brands.push(b); });
    data.products.forEach(function (p) {
      var v = norm(p.vendor);
      if (!v) return;
      self.brands.forEach(function (b) { if (norm(b.l) === v) brands.push(b); });
    });
    return { products: data.products.slice(0, 5), cats: uniq(cats).slice(0, 5), brands: uniq(brands).slice(0, 6) };
  };

  Header.prototype.productRow = function (p, q, cls) {
    var title = String(p.title || '');
    var t = q.toLowerCase();
    var i = t ? title.toLowerCase().indexOf(t) : -1;
    var titleKids = i < 0 ? [title] : [title.slice(0, i), h('mark', { 'class': 'wssh-hit' }, [title.slice(i, i + t.length)]), title.slice(i + t.length)];
    var src = p.image || (p.featured_image && p.featured_image.url) || '';
    var img = null;
    if (src) {
      src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=128';
      img = h('img', { src: src, alt: '', width: '64', height: '64', decoding: 'async' });
    }
    var min = p.price_min || p.price;
    var price = formatMoney(min, this.data.money);
    if (p.price_max && p.price_min && parseFloat(p.price_max) > parseFloat(p.price_min)) price = 'From ' + price;
    return h('a', { 'class': cls, href: p.url }, [
      h('span', { 'class': 'wssh-sres__img' }, [img]),
      h('span', { 'class': 'wssh-sres__t' }, [
        h('span', { 'class': 'wssh-sres__title' }, titleKids),
        p.vendor ? h('span', { 'class': 'wssh-sres__vendor' }, [p.vendor]) : null
      ]),
      h('span', { 'class': 'wssh-sres__price' }, [price])
    ]);
  };

  Header.prototype.noResultsNode = function () {
    if (this.noResults && this.noResults.content) return this.noResults.content.firstElementChild.cloneNode(true);
    return h('p', { 'class': 'wssh-noresults' }, ['No products match that search.']);
  };

  Header.prototype.render = function (mode, q, m) {
    var self = this;
    var seeAll = h('a', { 'class': 'wssh-mint', href: this.searchUrl(q) }, ['See all results for "' + q + '"', svg(ICON_ARROW, mode === 'p' ? 18 : 20, 2)]);
    var count = m.products.length;
    var msg = m.failed ? 'Search suggestions are not available right now.' : (count ? count + (count === 1 ? ' product' : ' products') + ' found' : 'No products found');

    if (mode === 'p') {
      var kids = [h('h2', { 'class': 'wssh-shead' }, ['Products'])];
      if (count) kids.push(h('div', { 'class': 'wssh-ps__list' }, m.products.map(function (p) { return self.productRow(p, q, 'wssh-sres2'); })));
      else if (!m.failed) kids.push(this.noResultsNode());
      if (m.brands.length) {
        kids.push(h('h2', { 'class': 'wssh-shead' }, ['Brands']));
        kids.push(h('div', { 'class': 'wssh-chips-wrap wssh-ps__chips' }, m.brands.map(function (b) { return h('a', { 'class': 'wssh-chip', href: b.u }, [b.l]); })));
      }
      kids.push(h('div', { 'class': 'wssh-ps__all' }, [seeAll]));
      this.psResults.textContent = '';
      kids.forEach(function (k) { self.psResults.appendChild(k); });
      this.psResults.removeAttribute('aria-busy');
      this.psEmpty.hidden = true;
      this.psResults.hidden = false;
      this.psStatus.textContent = msg;
      return;
    }

    var side = [];
    if (m.cats.length) {
      side.push(h('div', { 'class': 'wssh-col' }, [h('h3', { 'class': 'wssh-colhead2' }, ['Categories'])].concat(m.cats.map(function (c) {
        return h('a', { 'class': 'wssh-sublink', href: c.u }, [h('span', null, [c.l]), svg(ICON_RIGHT, 18, 2, 'wssh-go')]);
      }))));
    }
    if (m.brands.length) {
      side.push(h('div', { 'class': 'wssh-col wssh-col--gap8' }, [
        h('h3', { 'class': 'wssh-colhead2' }, ['Brands']),
        h('div', { 'class': 'wssh-chips-wrap' }, m.brands.map(function (b) { return h('a', { 'class': 'wssh-chip', href: b.u }, [b.l]); }))
      ]));
    }
    var main = [h('h3', { 'class': 'wssh-colhead2' }, ['Products'])];
    if (count) m.products.forEach(function (p) { main.push(self.productRow(p, q, 'wssh-sres')); });
    else if (!m.failed) main.push(this.noResultsNode());
    seeAll.classList.add('wssh-results__all');
    main.push(seeAll);

    var grid = h('div', { 'class': 'wssh-results__grid' + (side.length ? '' : ' wssh-results__grid--one') }, [
      side.length ? h('div', { 'class': 'wssh-results__side' }, side) : null,
      h('div', { 'class': 'wssh-results__main' }, main)
    ]);
    this.results.textContent = '';
    this.results.appendChild(grid);
    this.results.classList.remove('is-busy');
    this.results.removeAttribute('aria-busy');
    if (this.open === 'search') { this.results.hidden = false; this.sopen.hidden = true; }
    this.status.textContent = msg;
  };

  /* ---------------- Drawer (below 1220px) ---------------- */

  Header.prototype.initDrawer = function () {
    var self = this;
    this.drawer = qs(this.root, '[data-wssh-drawer]');
    this.burger = qs(this.root, '[data-wssh-drawer-open]');
    if (!this.drawer || !this.burger) return;
    this.drawerPanel = qs(this.drawer, '.wssh-drawer__panel');
    this.drawerBody = qs(this.drawer, '[data-wssh-drawer-body]');
    this.backBtn = qs(this.drawer, '[data-wssh-back]');
    this.on(this.burger, 'click', function () { self.openDrawer('root'); });
    qsa(this.drawer, '[data-wssh-drawer-close]').forEach(function (b) { self.on(b, 'click', function () { self.closeDrawer(true); }); });
    qsa(this.drawer, '[data-wssh-go]').forEach(function (b) {
      self.on(b, 'click', function () { self.goLevel(b.getAttribute('data-wssh-go'), b, false); });
    });
    this.on(this.backBtn, 'click', function () { self.goLevel('root', null, false); });
    this.on(this.drawer, 'keydown', function (e) { self.trap(e, self.drawerPanel); });
  };

  Header.prototype.openDrawer = function (level) {
    if (!this.drawer) return;
    this.close(false);
    if (!this.drawerOpen) {
      this.drawer.hidden = false;
      lock();
      this.drawerOpen = true;
      this.burger.setAttribute('aria-expanded', 'true');
    }
    this.levelFrom = null;
    this.goLevel(level || 'root', null, true);
    if ((level || 'root') === 'root') {
      var first = focusables(this.drawerPanel)[0];
      if (first) first.focus();
    }
  };

  Header.prototype.closeDrawer = function (returnFocus) {
    if (!this.drawerOpen) return;
    this.drawer.hidden = true;
    this.drawerOpen = false;
    unlock();
    this.burger.setAttribute('aria-expanded', 'false');
    if (returnFocus && isVisible(this.burger)) this.burger.focus();
  };

  Header.prototype.goLevel = function (id, fromBtn, instant) {
    var levels = qsa(this.drawer, '[data-wssh-level]');
    var target = levels.filter(function (l) { return l.getAttribute('data-wssh-level') === id; })[0];
    if (!target) { id = 'root'; target = levels[0]; }
    var sub = id !== 'root';
    levels.forEach(function (l) { l.hidden = l !== target; l.classList.remove('is-in', 'is-back'); });
    if (!instant) target.classList.add(sub ? 'is-in' : 'is-back');
    qsa(this.drawer, '[data-wssh-root-only]').forEach(function (el) { el.hidden = sub; });
    this.backBtn.hidden = !sub;
    this.drawerBody.scrollTop = 0;
    if (sub) {
      if (fromBtn) this.levelFrom = fromBtn;
      var title = qs(target, '.wssh-level__title');
      if (title) title.focus();
    } else if (!instant && this.levelFrom) {
      this.levelFrom.focus();
      this.levelFrom = null;
    }
  };

  Header.prototype.trap = function (e, box) {
    if (e.key !== 'Tab' || !box) return;
    var f = focusables(box);
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || !box.contains(active))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (active === last || !box.contains(active))) { e.preventDefault(); first.focus(); }
  };

  /* ---------------- Full-screen search (below 1220px) ---------------- */

  Header.prototype.initPhoneSearch = function () {
    var self = this;
    this.ps = qs(this.root, '[data-wssh-ps]');
    if (!this.ps) return;
    this.psForm = qs(this.ps, '[data-wssh-ps-form]');
    this.psInput = qs(this.ps, '[data-wssh-ps-q]');
    this.psEmpty = qs(this.ps, '[data-wssh-ps-empty]');
    this.psResults = qs(this.ps, '[data-wssh-ps-results]');
    this.psStatus = qs(this.ps, '[data-wssh-ps-status]');
    this.psOpeners = qsa(this.root, '[data-wssh-ps-open]');
    this.psOpeners.forEach(function (b) { self.on(b, 'click', function () { self.openPs(b); }); });
    this.on(qs(this.ps, '[data-wssh-ps-close]'), 'click', function () { self.closePs(true); });
    this.on(this.psInput, 'input', function () { self.queue('p', false); });
    this.on(this.psForm, 'submit', function (e) { self.submit(e, self.psInput); });
    qsa(this.ps, '[data-wssh-term]').forEach(function (b) {
      self.on(b, 'click', function () {
        self.psInput.value = b.getAttribute('data-wssh-term');
        self.psInput.focus();
        self.queue('p', true);
      });
    });
    this.on(this.ps, 'keydown', function (e) { self.trap(e, self.ps); });
  };

  Header.prototype.openPs = function (opener) {
    if (!this.ps) return;
    var fromDrawer = this.drawer && this.drawer.contains(opener);
    if (this.drawerOpen) this.closeDrawer(false);
    this.psReturn = fromDrawer ? this.burger : opener;
    this.ps.hidden = false;
    if (!this.psOpen) lock();
    this.psOpen = true;
    this.psOpeners.forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'true'); });
    this.psInput.focus();
  };

  Header.prototype.closePs = function (returnFocus) {
    if (!this.psOpen) return;
    this.ps.hidden = true;
    this.psOpen = false;
    unlock();
    this.psOpeners.forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'false'); });
    if (returnFocus && this.psReturn && isVisible(this.psReturn)) this.psReturn.focus();
  };

  /* ---------------- Cart count ---------------- */

  Header.prototype.initCart = function () {
    var self = this;
    this.countEls = qsa(this.root, '[data-wssh-count]');
    this.cartLinks = qsa(this.root, '[data-wssh-cart]');
    this.on(window, 'cartcount:update', function (e) {
      var d = e && e.detail;
      if (d && typeof d.item_count === 'number') self.setCount(d.item_count);
      else self.refreshCart();
    });
    this.on(window, 'pageshow', function (e) { if (e.persisted) self.refreshCart(); });
  };

  Header.prototype.setCount = function (n) {
    n = Math.max(0, parseInt(n, 10) || 0);
    this.countEls.forEach(function (el) { el.textContent = String(n); el.hidden = n < 1; });
    var label = 'Cart, ' + n + (n === 1 ? ' item' : ' items');
    this.cartLinks.forEach(function (a) { a.setAttribute('aria-label', label); });
  };

  Header.prototype.refreshCart = function () {
    var self = this;
    clearTimeout(this.timers.cart);
    this.timers.cart = setTimeout(function () {
      fetch(self.data.cart || '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') self.setCount(c.item_count); })
        .catch(function () { /* keep the current count */ });
    }, 250);
  };

  /* Cart changes made by apps (side carts, upsells) do not always fire Empire's event. */
  if (window.PerformanceObserver) {
    try {
      var cartRe = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
      new PerformanceObserver(function (list) {
        var changed = list.getEntries().some(function (en) {
          return (en.initiatorType === 'fetch' || en.initiatorType === 'xmlhttprequest') && cartRe.test(en.name);
        });
        if (changed) instances.forEach(function (i) { i.refreshCart(); });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* not supported */ }
  }

  /* ---------------- Theme editor ---------------- */

  Header.prototype.selectBlock = function (blockId) {
    if (DESKTOP.matches) {
      this.openPanel(blockId, false);
    } else {
      this.openDrawer(qs(this.drawer, '[data-wssh-level="' + blockId + '"]') ? blockId : 'root');
    }
  };

  function find(sectionId) {
    return instances.filter(function (i) { return i.sectionId === sectionId; })[0] || null;
  }

  function scan(scope) {
    qsa(scope, '[data-wssh]').forEach(function (root) {
      if (root.__wssh) return;
      root.__wssh = new Header(root);
      instances.push(root.__wssh);
    });
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (i) {
      if (e.target.contains(i.root)) { i.destroy(); return false; }
      return true;
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var i = e.detail && find(e.detail.sectionId);
    if (i) i.selectBlock(e.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var i = e.detail && find(e.detail.sectionId);
    if (i) i.closeAll();
  });

  window.WSSHeader = { scan: scan, instances: function () { return instances.slice(); } };
  scan(document);
})();
